/** @file Type guard: a channel's key list exists and is not empty. */

/** True for a defined, non-empty key array (empty channels are not exported). */
export function hasKeys<K>(keys: K[] | undefined): keys is K[] {
  return keys !== undefined && keys.length > 0;
}
